<template>
  <div class="dialog-edit-app-extend-wrapper">
    <el-dialog title="修改应用扩展字段" width="50%" :visible="visible" @open="onDialogOpen" @close="onDialogClose">

      <el-form label-position="top" ref="form" class="form" :rules="formRules" :model="form">

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="form.remarks" />
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onFormSubmit">确定</el-button>
          <el-button @click="onFormCancel">取消</el-button>
        </el-form-item>

      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DialogAddAppExtend',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    editingAppExtend: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formRules: {
        remarks: [
          { required: true, message: '请输入扩展字段名称', trigger: 'blur' }
        ]
      },
      form: {
        extend_param_id: 0,
        remarks: ''
      }
    }
  },
  computed: {
    ...mapState('store', [
      'appList'
    ])
  },
  methods: {
    ...mapActions('store', [
      'editAppExtendParam'
    ]),

    // 整理表单，验证数据
    cleanFormAndSubmit () {
      const clean = JSON.parse(JSON.stringify(this.form))

      // 提交表单
      this.performSubmit(clean)
    },
    async performSubmit (cleanForm) {
      try {
        await this.editAppExtendParam(cleanForm)

        this.$refs['form'].resetFields()
        this.$emit('update:visible', false)
        this.$emit('data-change')
      } catch (err) {
        this.$message({
          type: 'error',
          message: '修改应用扩展字段失败'
        })
        console.log(err)
      }
    },

    onFormSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.cleanFormAndSubmit()
        }
      })
    },
    onFormCancel () {
      this.$refs['form'].resetFields()
      this.$emit('update:visible', false)
    },

    onDialogOpen () {
      this.form.extend_param_id = this.editingAppExtend.extend_param_id
      this.form.remarks = this.editingAppExtend.remarks
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/base.scss';

.dialog-edit-app-extend-wrapper {
}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/DialogEditAppExtend.vue